import React, { useState } from "react";
import FeedbackStepLayout from "../FeedbackStepLayout";

const Step5Summary = ({ data, updateData, nextStep, prevStep }) => {
  const [summary, setSummary] = useState(data.lookbackNote || "");

  const handleNext = () => {
    if (!summary.trim()) return alert("Write a quick note before finishing!");
    updateData("lookbackNote", summary.trim());
    nextStep();
  };

  return (
    <FeedbackStepLayout
      title="This’ll be cool to look back on!"
      subtitle="If you could send a note to future-you, what would it say?"
      step={5}
      totalSteps={5}
      onNext={handleNext}
      onBack={prevStep}
    >
      <div className="flex flex-col items-center mt-10">
        <textarea
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          placeholder="Write your reflection here..."
          className="w-80 h-36 bg-stone-50 rounded-[10px]
                     shadow-[inset_0px_4px_4px_0px_rgba(0,0,0,0.25)]
                     text-sm text-neutral-700 p-3 font-['Inter'] resize-none outline-none
                     focus:ring-2 focus:ring-blue-400 focus:bg-white transition-all"
        />
      </div>
    </FeedbackStepLayout>
  );
};

export default Step5Summary;
